import { getElement, toggleVisibility } from '../utils/dom-utils';

export function showError(message: string): void {
  const errorEl = getElement('errorMessage');
  if (!errorEl) return;
  errorEl.textContent = message;
  toggleVisibility(errorEl, true);
}

export function hideError(): void {
  const errorEl = getElement('errorMessage');
  toggleVisibility(errorEl, false);
}
